import React from 'react';

import Layout from '../../components/layout';
import HomeCalculator from '../../components/calculators/home';

const DEFAULT_COST = 150000;
const DOWN_PAYMENT_FACTOR = 0.2;
const INSURANCE_FACTOR = 0.0005;
const USAGE_COSTS = 400;
const MAINTAINENCE_FACTOR = 0.004;

export default ({ location: { pathname } }) => (
    <Layout pathname={pathname}>
        <HomeCalculator
            pathname={pathname}
            title="Home Purchase Calculator"
            costOfAsset={DEFAULT_COST}
            downPayment={DEFAULT_COST * DOWN_PAYMENT_FACTOR}
            interestRate={2.5}
            loanPeriod={30}
            propertyTax={1.5}
            insurance={DEFAULT_COST * INSURANCE_FACTOR}
            usageCost={USAGE_COSTS}
            ownershipPeriod={10}
            feesYearly={0}
            zipCode={94612}
            maintenenceYearly={DEFAULT_COST * MAINTAINENCE_FACTOR}
            depreciationRate={0}
            pmi={300}
            hoa={50}
        />
    </Layout>
);
